module.exports = __webpack_public_path__ + "img/konto918_img.4826a670.png";